export default __webpack_public_path__ + "static/media/portfolio-131.4f008441.jpg";